import { FC } from "react";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";
import { motion } from "framer-motion";

interface StatCardProps {
  title: string;
  subtitle?: string;
  value: number | string;
  trend?: number;
}

const StatCard: FC<StatCardProps> = ({ title, subtitle, value, trend }) => {
  const hasTrend = typeof trend === "number";

  const isPositive = hasTrend && trend > 0;
  const isNegative = hasTrend && trend < 0;

  const trendConfig = hasTrend
    ? isPositive
      ? {
          badge: "bg-green-100 text-green-600",
          bar: "bg-green-600",
          icon: <TrendingUp className="w-4 h-4" />,
          label: `+${trend}`,
        }
      : isNegative
        ? {
            badge: "bg-red-100 text-red-600",
            bar: "bg-red-500",
            icon: <TrendingDown className="w-4 h-4" />,
            label: trend!.toString(),
          }
        : {
            badge: "bg-slate-100 text-slate-500",
            bar: "bg-slate-300",
            icon: <Minus className="w-4 h-4" />,
            label: "0",
          }
    : null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ y: -2 }}
      transition={{ duration: 0.3 }}
      className="relative bg-white rounded-2xl px-6 py-5 shadow-lg border border-slate-100 overflow-hidden"
    >
      {/* Title / Subtitle */}
      <div className="mb-3">
        <p className="text-xs font-semibold tracking-wide text-slate-500 uppercase">
          {title}
        </p>
        {subtitle && (
          <p className="text-xs text-slate-400 mt-0.5">{subtitle}</p>
        )}
      </div>

      {/* Value + Trend */}
      <div className="flex items-center justify-between">
        <p className="text-4xl font-bold text-slate-900 leading-none">
          {value}
        </p>

        {trendConfig && (
          <div
            className={`flex items-center gap-1 px-3 py-1 rounded-full text-sm font-semibold ${trendConfig.badge}`}
          >
            {trendConfig.icon}
            <span>{trendConfig.label}</span>
          </div>
        )}
      </div>

      {/* Barra inferior */}
      {trendConfig && (
        <div
          className={`absolute bottom-0 left-0 h-1 w-full ${trendConfig.bar}`}
        />
      )}
    </motion.div>
  );
};

export default StatCard;
